/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Sidebar_Toggle_DescriptionInputs */

const es_walkthrough_sidebar_toggle_description = /** @type {(inputs: Walkthrough_Sidebar_Toggle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colapsar o expandir la barra lateral en cualquier momento. También podés usar el atajo Ctrl+B (Cmd+B en Mac).`)
};

const en_walkthrough_sidebar_toggle_description = /** @type {(inputs: Walkthrough_Sidebar_Toggle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse or expand the sidebar at any time. You can also use the shortcut Ctrl+B (Cmd+B on Mac).`)
};

/**
* | output |
* | --- |
* | "Collapse or expand the sidebar at any time. You can also use the shortcut Ctrl+B (Cmd+B on Mac)." |
*
* @param {Walkthrough_Sidebar_Toggle_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_sidebar_toggle_description = /** @type {((inputs?: Walkthrough_Sidebar_Toggle_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Sidebar_Toggle_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_sidebar_toggle_description(inputs)
	return en_walkthrough_sidebar_toggle_description(inputs)
});
export { walkthrough_sidebar_toggle_description as "walkthrough.sidebar_toggle_description" }